import angular from "angular";

import { moduleName as recordsModuleName } from "../../../records";
import { vsModuleName as shareMachineModuleName } from "../../shared";
import { machineConfigurationConfig } from "./machineConfiguration";
import { machineDetailTabComponentConfigure } from "./configureMachineDetailTabs";
import { machineConfig } from "./machine";

import { vsModuleName as lookupConfigModuleName } from "./lookup/module";
import { machineEpromConfigurationConfig } from "./machineEpromConfigurations";
import { machineConfigurationTypeConfig } from "./machineConfigurationType";
import {
  MachineConfigurationCellClassServiceProvider,
  vsServiceName as machineConfigurationCellClassName,
} from "../../shared/machineConfigurationCellClassService";
import { vsModuleName as changesConfigModule } from "./changes";
import { machineGameConfigurationTypeGameConfigurationConfig } from "./machineConfigurationTypeGameConfiguration";
import { machineConfigurationFileConfig } from "./machineConfigurationFile";
import { vsModuleName as ChangeJournalConfigModule } from "./changeJournal/module";

export const vsModuleName = "SlotTrak.Machines.Config";

angular
  .module(vsModuleName, [
    recordsModuleName,
    shareMachineModuleName,
    lookupConfigModuleName,
    changesConfigModule,
    ChangeJournalConfigModule,
  ])
  .config(machineConfigurationConfig)
  .config(machineDetailTabComponentConfigure)
  .config(machineConfig)
  .config(machineEpromConfigurationConfig)
  .config(machineConfigurationTypeConfig)
  .config(machineGameConfigurationTypeGameConfigurationConfig)
  .config(machineConfigurationFileConfig)
  .provider(
    machineConfigurationCellClassName,
    MachineConfigurationCellClassServiceProvider
  );
